import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import Classes from '../styles/style.module.css'
import { AnimatePresence, motion } from 'framer-motion'
import VideoPlayer from './VideoPlayer';

export default function ViewVideo({ handleSubmit, handleBack, direction, setActiveMsg, setShowVideo }) {
    const onBoarding = useSelector((state) => state.companyInfo.info);
    onBoarding.color = '#3E9BFF';

    // YouTube video ID extracted from the URL

    return (
        <>
            <motion.div
                initial={{ x: direction === "forward" ? 20 : -20, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: direction === "forward" ? -20 : 20, opacity: 0 }}
                transition={{ duration: 0.25 }}
                className={Classes.cardCon}
            >
                <h5 className={`${Classes.text2} ${Classes.m1r}`}>
                    Your dashboard has powerful tools for onboarding <br />
                    and managing clients and projects. Watch this <br />
                    walkthrough to explore all its features!
                </h5>

                <div className={Classes.videoCon} onClick={() => setShowVideo(true)} >
                    <button
                        className={Classes.playButton}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" height='25px' fill='#848484' viewBox="0 0 384 512"><path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z" /></svg>
                    </button>
                </div>

                <div className={Classes.flexAlign}>
                    <button
                        type="button"
                        onClick={handleSubmit}
                        className={Classes.btn2}
                        style={{
                            background: onBoarding.color || "black",
                            border: `1px solid ${onBoarding.color}`
                        }}
                    >
                        <h5>Continue to dashboard</h5>
                    </button>
                </div>
            </motion.div>
        </>
    )
}